'use client'

import { createContext, useContext, useState, useEffect, ReactNode } from 'react'
import { useUserProfile } from '@/hooks/use-user'

interface PreferencesModalContextType {
  showModal: boolean
  closeModal: () => void
}

const PreferencesModalContext = createContext<PreferencesModalContextType | undefined>(undefined)

export function PreferencesModalProvider({ children }: { children: ReactNode }) {
  const [showModal, setShowModal] = useState(false)
  const { userProfile, loading } = useUserProfile()

  useEffect(() => {
    if (!loading && userProfile?.id) {
      const modalKey = `user-${userProfile.id}-preference-modal`
      const hasSeenModal = localStorage.getItem(modalKey)
      
      if (!hasSeenModal) {
        setTimeout(() => {
          setShowModal(true)
        }, 500)
      }
    }
  }, [loading, userProfile?.id])

  const closeModal = () => {
    if (userProfile?.id) {
      const modalKey = `user-${userProfile.id}-preference-modal`
      localStorage.setItem(modalKey, 'true')
      setShowModal(false)
    }
  }

  return (
    <PreferencesModalContext.Provider value={{ showModal, closeModal }}>
      {children}
    </PreferencesModalContext.Provider>
  )
}

export function usePreferencesModal() {
  const context = useContext(PreferencesModalContext)
  if (context === undefined) {
    throw new Error('usePreferencesModal must be used within a PreferencesModalProvider')
  }
  return context
}

